"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Drawer = ({
  children,
  title,
  open,
  parentBorderOffset,
  position,
  ...otherProps
}) => {
  const [isOpen, setIsOpen] = (0, _react.useState)(!!open);
  const drawerId = (0, _uuid.v4)();
  const scrollAreaRef = (0, _react.useRef)();
  const toggleDrawer = (0, _react.useCallback)(() => {
    setIsOpen(!isOpen);
  }, [setIsOpen, isOpen]);
  (0, _react.useEffect)(() => {
    if (isOpen) {
      scrollAreaRef.current.scrollTop = 0;
    }
  }, [isOpen, scrollAreaRef]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DrawerSpacer, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledDrawer, {
      open: isOpen,
      position: position,
      parentBorderOffset: parentBorderOffset,
      ...otherProps,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DrawerHeader, {
        parentBorderOffset: parentBorderOffset,
        id: `drawer-heading-${drawerId}`,
        "aria-expanded": isOpen,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DrawerTitle, {
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DrawerButton, {
          primary: true,
          onClick: toggleDrawer,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ArrowIcon, {})
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DrawerContent, {
        parentBorderOffset: parentBorderOffset,
        role: "region",
        "aria-labelledby": `drawer-heading-${drawerId}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ScrollArea, {
          scrollableNodeProps: {
            ref: scrollAreaRef
          },
          children: children
        })
      })]
    })]
  });
};

Drawer.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  title: _propTypes.default.string,
  position: _propTypes.default.string,
  parentBorderOffset: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Drawer.defaultProps = {
  parentBorderOffset: 0
};
var _default = Drawer;
exports.default = _default;